module.exports = __webpack_public_path__ + "img/espaycrow-logo-dark.359803e0.png";